/**
 * Tipos de lotação de um defensor.
 */
export enum TipoLotacao {
  Substituicao = 0,
  Acumulacao = 1,
  Titularidade = 2,
  Designacao_Principal = 3,
  Designacao = 4,
  Estagio_Voluntario = 5,
  Estagio_Obrigatorio = 6,
  Estagio_Nao_Obrigatorio = 7,
  Designacao_Especial = 8,
}